
class Api {
  constructor(base_url, key, path) {
    this.base_url = base_url;
    this.key = key;
    this.path = path;
  }

  async call(path, method = 'GET', body = {}) {
    const options = {
      headers: this.headers(),
      method: method,
      mode: 'cors'
    };

    if ((method === 'POST' || method === 'PATCH') && body) {
      options.body = JSON.stringify(body);
    }

    return await fetch(this.base_url + path, options)
    .then(this.checkStatus)
    .then(this.parseJSON);
  }

  headers() {
    return new Headers({
      "Content-Type": "applicaiton/json",
      "x-ptp-auth": Buffer.from(this.key + ':::' + this.path).toString('base64')
    });
  }

  checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    const error = new Error(`HTTP Error ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
    throw error;
  }

  parseJSON(response) {
    return response.json();
  }
}

let apiObject = null;

function setupApi(base_url, key, path) {
  if (!apiObject) {
    apiObject = new Api(base_url, key, path);
  }

  return apiObject;
}

export default setupApi;


// WEBPACK FOOTER //
// ./src/libs/Api.js